import aiAPI from '@edulastic/api/src/aiAPI'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { createSelector } from 'reselect'

export const namespaceKey = 'aiTranslate'

// actions constants
export const GENERATE_AI_TRANSLATED_CONTENT = `[${namespaceKey}] generate translated content`
export const SET_AI_TRANSLATE_STATE = `[${namespaceKey}] set state`
export const RESET_AI_TRANSLATE_STATE = `[${namespaceKey}] reset state`

// actions
export const generateAITranslatedContentAction = (payload) => ({
  type: GENERATE_AI_TRANSLATED_CONTENT,
  payload,
})

export const setAITranslateContentStateAction = (payload) => ({
  type: SET_AI_TRANSLATE_STATE,
  payload,
})

export const resetAITranslateContentStateAction = () => ({
  type: RESET_AI_TRANSLATE_STATE,
})

// selectors
export const stateSelector = (state) => state?.[namespaceKey]

export const getAITranslateContentState = createSelector(
  stateSelector,
  (state) => state || {}
)

// initial state
const initialState = {
  apiStatus: null,
  result: null,
  errorMessage: null,
}

// reducer
export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_AI_TRANSLATE_STATE:
      return {
        ...state,
        ...payload,
      }
    case RESET_AI_TRANSLATE_STATE:
      return {
        ...initialState,
      }
    default:
      return state
  }
}

// sagas
function* generateAITranslatedContentSaga({ payload }) {
  const generalErrorMessage = 'Something went wrong'

  try {
    yield put(
      setAITranslateContentStateAction({
        apiStatus: 'INITIATED',
        result: null,
        errorMessage: null,
      })
    )
    const { result } = yield call(aiAPI.generateTranslatedContent, payload)
    yield put(
      setAITranslateContentStateAction({
        apiStatus: 'SUCCESS',
        result,
        errorMessage: null,
      })
    )
  } catch (err) {
    yield put(
      setAITranslateContentStateAction({
        apiStatus: 'FAILED',
        result: null,
        errorMessage: err?.message || generalErrorMessage,
      })
    )
  }
}

export function* watcherSaga() {
  yield all([
    takeEvery(GENERATE_AI_TRANSLATED_CONTENT, generateAITranslatedContentSaga),
  ])
}
